import {useHistory} from "react-router-dom";
import React, {useContext} from "react";
import {AuthContext} from "../../../context/AuthContext";
import {observer} from "mobx-react";
import styled from "styled-components";

var LinkToCounterAgent = observer((props) => {
    const history = useHistory()
    const {roleId} = useContext(AuthContext)

    const verificationCenter = {
        ...props?.info?.verificationCenter
    }
    const medCenter = {
        ...props?.info?.medCenter
    }
    const organization = {
        ...props?.info?.organization
    }


    const links = {
        2: {
            verificationCenter: verificationCenter?._id
                && verificationCenter?.name
                && `/counterAgents/verificationCenters/${verificationCenter?._id}/${encodeURIComponent(verificationCenter?.name)}/all`,

            medCenter: verificationCenter?._id
                && medCenter?._id
                && medCenter?.name
                && medCenter?._id
                && `/counterAgents/verificationCenters/${verificationCenter?._id}/${encodeURIComponent(verificationCenter?.name)}/medCentres/${medCenter?._id}/${encodeURIComponent(medCenter?.name)}/organizations`,

            organization: verificationCenter?._id
                && verificationCenter?.name
                && organization?._id
                && organization?.name
                && `${medCenter?.name && medCenter?._id

                    ? `/counterAgents/verificationCenters/${verificationCenter?._id}/${encodeURIComponent(verificationCenter?.name)}/medCentres/${medCenter?._id}/${encodeURIComponent(medCenter?.name)}/organizations/${organization?._id}/${encodeURIComponent(organization?.name)}/history`
                    : `/counterAgents/organizations/${organization?._id}/${verificationCenter?._id}/${encodeURIComponent(organization?.name)}/history`}`
        },
        5: {
            medCenter: medCenter?.name
                && medCenter?._id
                && `/counterAgents/MedCenterOrgList/${medCenter?._id}/${medCenter?.name}`,
            organization: organization?._id
                && organization?.name
                && `${
                    medCenter?.name
                    && medCenter?._id
                        ? `/counterAgents/MedCenterOrgList/${medCenter?._id}/${encodeURIComponent(medCenter?.name)}/organizations/${organization?._id}/${encodeURIComponent(organization?.name)}`
                        : `/counterAgents/allOrgList/orgHistory/${organization?._id}/${encodeURIComponent(organization?.name)}`}`
        }
    }

    const link = links[roleId][props.type]
    const onClick = () => {
        history.push(process.env.REACT_APP_URL_PREFIX + link)
    }

    return (
        <Styled>
            {props.children}
            {
                link && <div onClick={onClick} className='linkTo'>
                    <i className='fas fa-arrow-right'/>

                </div>
            }


        </Styled>
    )
})
const Styled = styled.div`
  position: relative;

  .fas {
    color: cornflowerblue;
  }

  .linkTo {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 10px;
    top: 42px;
    cursor: pointer;
  }

  @media (max-width: 1100px) {
    .linkTo {
      top: 29px;
    }

  }


`
export default LinkToCounterAgent